<template>
  <div :style="cssVars">
    <page-layout
      :noSideBar="false"
      :headerBackgroundColor="cssVars['--outcome-primary']"
    >
      <template v-slot:headerContent>
        <div class="row">
          <span
            :style="`color: ${cssVars['--outcome-secondary']}`"
            class="title"
          >
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row items-center" style="position: relative">
          <span class="headerText text-white">
            {{
              selectedOutcome
                ? "Assessment Tools for"
                : "You need to select an outcome first"
            }}
          </span>
          <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`min-width: 230px;
                    max-width: 500px;
                      background-color: ${cssVars['--outcome-secondary']};
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            disable
          ></sustainability-dropdown>
          <span class="headerText text-white q-mx-sm"> in </span>
          <year-picker
            ref="yearPicker"
            label=""
            :bg="cssVars['--outcome-secondary']"
            @selectYear="selectYear"
          ></year-picker>
          <q-img
            class="float-right"
            :src="getWhiteOutcomeImage(selectedOutcome)"
            style="position: absolute; right: 15px; width: 69px; top: -20px"
          ></q-img>
        </div>
      </template>
      <template v-slot:content>
        <div class="column content">
          <div class="col-auto" style="height: calc(100vh - 226px)">
            <div class="row q-px-lg q-gutter-x-lg" v-if="selectedOutcome">
              <div class="col q-py-lg">
                <h4>"Where are you today?"</h4>
                <p>Please select what assessment tool you'd like to use</p>
              </div>
            </div>
            <div
              class="row items-center justify-center q-px-lg q-gutter-x-xl"
              style="height: calc(100vh - 374px)"
            >
              <div class="col-auto q-px-md text-center">
                <q-card
                  class="
                    assessmentToolCard
                    items-center
                    row
                    text-center
                    cursor-pointer
                  "
                  @click="selectedAssessmentTool = 'Story'"
                  :style="`background: ${
                    selectedAssessmentTool == 'Story'
                      ? cssVars['--outcome-secondary']
                      : '#d1d1d1'
                  }`"
                  flat
                >
                  <q-icon
                    name="mdi-book-open-page-variant-outline"
                    color="white"
                    size="90px"
                    style="margin: auto"
                  ></q-icon>
                </q-card>
                <h3
                  class="q-my-xs"
                  :style="`color: ${
                    selectedAssessmentTool == 'Story'
                      ? cssVars['--outcome-secondary']
                      : '#d1d1d1'
                  }`"
                >
                  Story
                </h3>
              </div>
              <div
                v-if="
                  selectedOutcome && selectedOutcome.dataAssessmentTool == 1
                "
                class="col-auto q-px-md text-center"
              >
                <q-card
                  class="
                    assessmentToolCard
                    items-center
                    row
                    text-center
                    cursor-pointer
                  "
                  @click="selectedAssessmentTool = 'Data'"
                  :style="`background: ${
                    selectedAssessmentTool == 'Data'
                      ? cssVars['--outcome-secondary']
                      : '#d1d1d1'
                  }`"
                  flat
                >
                  <q-icon
                    name="mdi-chart-line"
                    color="white"
                    size="90px"
                    style="margin: auto"
                  ></q-icon>
                </q-card>
                <h3
                  class="q-my-xs"
                  :style="`color: ${
                    selectedAssessmentTool == 'Data'
                      ? cssVars['--outcome-secondary']
                      : '#d1d1d1'
                  }`"
                >
                  Data
                </h3>
              </div>
<!--              <div-->
<!--                v-if="-->
<!--                  selectedOutcome && selectedOutcome.scaleAssessmentTool == 1-->
<!--                "-->
<!--                class="col-auto q-px-md text-center"-->
<!--              >-->
<!--                <q-card-->
<!--                  class="-->
<!--                    assessmentToolCard-->
<!--                    items-center-->
<!--                    row-->
<!--                    text-center-->
<!--                    cursor-pointer-->
<!--                  "-->
<!--                  @click="selectedAssessmentTool = 'Scale'"-->
<!--                  :style="`background: ${-->
<!--                    selectedAssessmentTool == 'Scale'-->
<!--                      ? cssVars['&#45;&#45;outcome-secondary']-->
<!--                      : '#d1d1d1'-->
<!--                  }`"-->
<!--                  flat-->
<!--                >-->
<!--                  <q-icon-->
<!--                    name="mdi-format-list-checks"-->
<!--                    color="white"-->
<!--                    size="90px"-->
<!--                    style="margin: auto"-->
<!--                  ></q-icon>-->
<!--                </q-card>-->
<!--                <h3-->
<!--                  class="q-my-xs"-->
<!--                  :style="`color: ${-->
<!--                    selectedAssessmentTool == 'Scale'-->
<!--                      ? cssVars['&#45;&#45;outcome-secondary']-->
<!--                      : '#d1d1d1'-->
<!--                  }`"-->
<!--                >-->
<!--                  Scale-->
<!--                </h3>-->
<!--              </div>-->
            </div>
          </div>
          <div class="col q-px-md">
            <q-btn
              class="q-px-sm q-py-xs bg-secondary"
              label="Back to Choosing an Outcome"
              text-color="white"
              color="secondary"
              no-caps
              flat
              @click="
                $router.push(`${$route.path.split('/chooseAssessmentTool')[0]}`)
              "
            >
            </q-btn>
          </div>
        </div>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div
            class="col-auto q-pt-lg q-px-lg q-pb-sm"
            style="height: calc(109px)"
          >
            <h3>Tool Insight</h3>
          </div>
          <div class="col-auto q-pa-lg" style="height: calc(100vh - 226px)">
            <div v-if="selectedAssessmentTool">
              <h4>
                {{ selectedAssessmentTool }}
              </h4>
              <div v-html="assessmentToolText(selectedAssessmentTool)"></div>
            </div>
            <div v-else style="height: calc(100vh - 250px)">
              <h4 class="text-center" style="max-width: 90%; margin: auto">
                Select a tool to reveal info about how they work
              </h4>
            </div>
          </div>
          <div class="col q-px-md" v-if="selectedAssessmentTool">
            <q-btn
              v-if="selectedAssessmentTool == 'Data'"
              no-caps
              label="Redo Questionnaire"
              color="negative"
              flat
              :loading="resettingQuestionnaire"
              @click="resetQuestionnaire"
            ></q-btn>
            <q-btn
              class="q-px-sm q-py-xs bg-accent float-right"
              :label="
                outcomePlan && outcomePlan.currentStep ? 'Continue' : 'Start'
              "
              text-color="white"
              color="accent2"
              no-caps
              flat
              @click="startWithAssessmentTool()"
            >
            </q-btn>
          </div>
        </div>
      </template>
    </page-layout>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import PageLayout from "@/components/pageLayout/pageLayout.vue";
  import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
  import { assessmentToolText } from "@/functions/assessmentToolText.js";
  import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";

  import YearPicker from "@/components/generalComponents/yearPicker.vue";

  export default {
    components: {
      YearPicker,
      PageLayout,
      SustainabilityDropdown,
    },
    async mounted() {
      if (this.selectedOutcome) {
        this.initSelectedOutcome();
      }
      this.selectYear(this.$moment().format("YYYY"));
    },
    data: () => ({
      outcome: null,
      selectedYear: null,
      selectedAssessmentTool: null,

      resettingQuestionnaire: false,
    }),
    watch: {
      selectedOutcome: function () {
        this.initSelectedOutcome();
      },
    },
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        currentUserData: "auth/currentUserData",
        outcomePlan: "businessOutcomePlans/current",
        outcomePlanLoading: "businessOutcomePlans/currentLoading",
        selectedOutcome: "businessOutcomePlans/selectedOutcome",
      }),
      cssVars() {
        let primaryColorFaded = this.selectedOutcome
          ? this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor.split("#")
            : ["", "162c47"]
          : "#162c47";
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
        if (this.selectedOutcome) {
          return {
            "--outcome-primary": this.selectedOutcome.primaryColor
              ? this.selectedOutcome.primaryColor
              : "#162c47",
            "--outcome-secondary": this.selectedOutcome.secondaryColor
              ? this.selectedOutcome.secondaryColor
              : "#162c47",
            "--outcome-tertiary": this.selectedOutcome.tertiaryColor
              ? this.selectedOutcome.tertiaryColor
              : "#162c47",
            "--outcome-primary-faded": primaryColorFadedString,
          };
        } else {
          return {
            "--outcome-primary": "#162c47",
            "--outcome-secondary": "white",
            "--outcome-tertiary": "#162c47",
            "--outcome-primary-faded": "#162c47",
          };
        }
      },
    },
    methods: {
      getWhiteOutcomeImage: getWhiteOutcomeImage,

      assessmentToolText: assessmentToolText,
      initSelectedOutcome() {
        this.outcome = this.selectedOutcome;
      },
      startWithAssessmentTool() {
        switch (this.selectedAssessmentTool) {
          case "Story":
            this.continueStoryAssessmentTool();
            break;

          case "Data":
            this.continueDataAssessmentTool();
            break;

          // case "Scale":
          //   this.continueScaleAssessmentTool();
          //   break;

          default:
            break;
        }
      },
      continueDataAssessmentTool() {
        switch (this.outcomePlan.questionnaireCompleted) {
          case 0:
            this.$router.push(
              `${
                this.$route.path.split("chooseAssessmentTool")[0]
              }outcomePlanQuestionnaire`
            );
            break;
          case 1:
            this.$router.push(
              `${
                this.$route.path.split("chooseAssessmentTool")[0]
              }dataUpload/year/${this.selectedYear}`
            );
            break;

          default:
            break;
        }
      },
      // continueScaleAssessmentTool() {
      //   this.$router.push(
      //     `${this.$route.path.split("chooseAssessmentTool")[0]}scale`
      //   );
      // },
      continueStoryAssessmentTool() {
        this.$router.push(
          `${this.$route.path.split("chooseAssessmentTool")[0]}storyBoard`
        );
      },
      async resetQuestionnaire() {
        const res = await this.$swal({
          title: "Warning",
          text: "You are about to Reset the questionnaire for this plan. This will un-star ALL data source lines that do not currently have data in them. Do you wish to continue?",
          type: "warning",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        });

        if (res.value) {
          this.resettingQuestionnaire = true;
          try {
            let response = await this.$store.dispatch(
              "businessOutcomePlans/resetQuestionnaire",
              {
                id: this.selectedOutcome.id,
                outcomePlan_id: this.outcomePlan.id,
              }
            );

            this.$store.dispatch(
              "businessOutcomePlans/loadByOutcomeID",
              this.selectedOutcome.id
            );
            this.$q.notify({
              position: "top-right",
              type: response.Result == "Success" ? "positive" : "negative",
              message: response.Response.Message,
            });
            this.$router.push(
              `${
                this.$route.path.split("chooseAssessmentTool")[0]
              }outcomePlanQuestionnaire`
            );
          } catch (error) {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an error, Please try again later",
            });
          }
          this.resettingQuestionnaire = false;
        }
      },
      selectYear(val) {
        this.selectedYear = val.split("/")[0];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sidebar {
    h3 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1.3rem;
      line-height: 29px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }

    h4 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1rem;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }
  }

  .content {
    h4 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 800;
      font-size: 1.4rem;
      line-height: 1.5rem;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }
    p {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 400;
      font-size: 1.2rem;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: -0.02em;
      color: $accent2;
      margin: 10px 0px;
    }

    h3 {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 1.3rem;
      line-height: 29px;
      letter-spacing: -0.02em;
    }

    .assessmentToolCard {
      width: 140px;
      height: 140px;
      border-radius: 30px;
      margin: auto;
      transition: all 0.2s;
    }
  }

  .headerText {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
  }

  .questionTitle {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
  }

  .button-bg {
    background-color: var(--outcome-secondary);
  }

  .button-text {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 11.6054px;
  }
</style>
